var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"put-status column-flex"},[_c('img',{attrs:{"src":require('@/assets/' + _vm.icon + '.png')}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.info))]),_vm._v(" "),(_vm.hasBtn)?_c('div',{staticClass:"btn",on:{"click":_vm.toPage}},[_vm._v("去任务中心查看")]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d271667","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shareCommon/put-status.vue
// module id = null
// module chunks = 